import InActive from '../../assets/icons/inactive.svg';
import Active from '../../assets/icons/active.svg';
import Neutral from '../../assets/icons/neutral.svg';
import {
  INVOICE_STATUS_NOT_PAID,
  INVOICE_STATUS_PAID,
  INVOICE_STATUS_PARTIALLY_PAID,
  BC_SYNC_STATUS_SYNCED,
  BC_SYNC_STATUS_FAILED,
  BC_SYNC_STATUS_NOT_SENT,
} from '../../pages/invoices/constants';
import {
  CAMPAIGN_STATUS_ACTIVE,
  CAMPAIGN_STATUS_ACTIVE_NAME,
  CAMPAIGN_STATUS_DRAFT,
  CAMPAIGN_STATUS_DRAFT_NAME,
  CAMPAIGN_STATUS_ERROR,
  CAMPAIGN_STATUS_ERROR_NAME,
  CAMPAIGN_STATUS_SENT,
  CAMPAIGN_STATUS_SENT_NAME,
  CAMPAIGN_TYPE_PUSH,
  CAMPAIGN_TYPE_SMS,
  CAMPAIGN_TYPE_SMS_PUSH,
} from '../../pages/campaignNotifications/constants';
import { LoyaltyProgramStatus } from './enums';

export const mapUserStatus = status => {
  switch (status) {
    case 0:
      return 'Deaktyvuotas';
    case 1:
      return 'Aktyvus';
    default:
      return '-';
  }
};

export const mapEmployeeType = type => {
  switch (type) {
    case 1401:
      return 'Programėlė';
    case 1402:
      return 'Kortelė';
    default:
      return 'Programėlė';
  }
};

export const mapBusinessInvoiceStatus = status => {
  switch (status) {
    case 1:
      return 'Apmokėta';
    default:
      return 'Neapmokėta';
  }
};

export const mapOnOffStatus = status => {
  switch (status) {
    case 0:
      return 'Išjungtas';
    case 1:
      return 'Įjungtas';
    default:
      return '-';
  }
};

export const serviceTypes = [
  20,
  21,
  22,
  23,
  24,
  25,
  26,
  27,
  28,
  29,
  30,
  31,
  40,
  41,
  50,
];

export const mapServiceTypes = type => {
  switch (type) {
    case 20:
      return 'Virtualios piniginės pildymas';
    case 21:
      return 'Savitarna';
    case 22:
      return 'Automatinė bekontaktė';
    case 23:
      return 'Automatinė tekstilinė';
    case 24:
      return 'Dulkių siurblys';
    case 25:
      return 'Šluostės';
    case 26:
      return 'Langų skystis';
    case 27:
      return 'Kilimėlių plovimas';
    case 28:
      return 'Išmanus dulkių siurblys';
    case 29:
      return 'Padangų juodinimas';
    case 30:
      return 'Sausinimo rankšluostis';
    case 31:
      return 'Džiovyklė';
    case 40:
      return 'H2 kortelės papildymas';
    case 41:
      return 'H2 kortelės pirkimas';
    case 50:
      return 'Dovanų kuponas';
    default:
      return '-';
  }
};

export const selfServiceTypes = [101, 102, 103, 104, 105];

export const mapSelfServiceTypes = type => {
  switch (type) {
    case 101:
      return 'Atmirkymas';
    case 102:
      return 'Plovimas';
    case 103:
      return 'Skalavimas';
    case 104:
      return 'Vaškavimas';
    case 105:
      return 'Džiovinimas';
    default:
      return '-';
  }
};

export const serviceTypesNames = [
  'self_service_washing',
  'automatic_textile_washing',
  'automatic_contactless_washing',
  'vacuum_cleaner',
  'smart_vacuum_cleaner',
  'car_mat_cleaner',
  'paper_towel_dispenser',
  'windshield_washer_liquid_dispenser',
  'tyre_blackener',
  'towel_dispenser',
];

export const mapServiceTypesNames = location => {
  switch (location) {
    case 'self_service_washing':
      return 'Savitarna';
    case 'automatic_textile_washing':
      return 'Automatinė tekstilinė';
    case 'automatic_contactless_washing':
      return 'Automatinė bekontaktė';
    case 'vacuum_cleaner':
      return 'Dulkių siurblys';
    case 'smart_vacuum_cleaner':
      return 'Išmanus dulkių siurblys';
    case 'car_mat_cleaner':
      return 'Kilimėlių plovimo automatas';
    case 'paper_towel_dispenser':
      return 'Šluosčių pardavimo automatas';
    case 'windshield_washer_liquid_dispenser':
      return 'Langų skysčio papildymo automatas';
    case 'tyre_blackener':
      return 'Padangų juodinimo aparatas';
    case 'towel_dispenser':
      return 'Sausinimo rankšluostis';
    case 'cash_registers':
      return 'Kasos įrenginys';
    default:
      return '';
  }
};

export const membershipTypes = [30, 31, 32, 33];

export const mapMembershipType = type => {
  switch (type) {
    case 30:
      return 'Pagal užsakymą';
    case 31:
      return 'Sidabrinis';
    case 32:
      return 'Auksinis';
    case 33:
      return 'Deimantinis';
    case 34:
      return 'Baltas';
    case 35:
      return 'Žalias';
    case 36:
      return 'Raudonas';
    case 38:
      return 'Pagrindinis';
    case 39:
      return 'Šešėlinis';
    default:
      return '-';
  }
};

export const paymentTypes = [91, 92];

export const mapPaymentType = type => {
  switch (type) {
    case 91:
      return 'Privatus';
    case 92:
      return 'Verslas';
    default:
      return '-';
  }
};

export const paymentMethods = [
  371,
  372,
  373,
  374,
  481,
  482,
  483,
  484,
  485,
  486,
];

export const mapPaymentMethod = (type, payment_card_type) => {
  switch (type) {
    case 371:
      return payment_card_type || 'Mokėjimo kortelė';
    case 372:
      return 'Virtuali piniginė';
    case 373:
      return 'Sutartis';
    case 374:
      return 'Vienkartinis mokėjimas';
    case 481:
      return payment_card_type || 'Kreditinė kortelė';
    case 482:
      return 'Google Pay';
    case 483:
      return 'Apple Pay';
    case 484:
      return 'Revolut Pay';
    case 485:
      return 'Bankai';
    case 486:
      return 'Paysera';
    default:
      return '-';
  }
};

export const discountStatuses = [171, 172, 173, 174];

export const mapDiscountStatus = status => {
  switch (status) {
    case 171:
      return 'Laukiama';
    case 172:
      return 'Galioja';
    case 173:
      return 'Pasibaigusi';
    case 174:
      return 'Deaktyvuota';
    default:
      return '-';
  }
};

export const discountGroups = [188, 187, 186, 185];

export const mapDiscountGroup = group => {
  switch (group) {
    case 181:
      return 'Visi klientai';
    case 185:
      return 'Klientai neturintys paso';
    case 186:
      return 'Baltas';
    case 187:
      return 'Žalias';
    case 188:
      return 'Raudonas';
    default:
      return '-';
  }
};

export const businessStatuses = [1951, 1952, 1953];

export const mapBusinessStatus = status => {
  switch (status) {
    case 1951:
      return 'Su kontraktu';
    case 1952:
      return 'Be kontrakto';
    case 1953:
      return 'Privatus';
    default:
      return '-';
  }
};

export const campaignBusinessStatuses = [1951, 1952, 1953];

export const mapCampaignBusinessStatus = status => {
  switch (status) {
    case 1951:
      return 'Verslas su sutartimi';
    case 1952:
      return 'Verslas be sutarties';
    case 1953:
      return 'Privatus';
    default:
      return '-';
  }
};

export const serviceOptionTypes = [201, 202, 203, 204];

export const mapServiceOptionType = status => {
  switch (status) {
    case 201:
      return 'ORANGE';
    case 202:
      return 'PRO';
    case 203:
      return 'VIP';
    case 204:
      return 'ELITE';
    default:
      return '-';
  }
};

export const mapDeviceTypes = type => {
  switch (type) {
    case 201:
    case 'self_service_washing':
      return 'Boksas';
    case 202:
      return 'Atviras boksas';
    case 211:
    case 'automatic_textile_washing':
      return 'Tekstilinė';
    case 212:
    case 'automatic_contactless_washing':
      return 'Bekontaktė';
    case 221:
    case 'vacuum_cleaner':
      return 'Siurblys';
    case 222:
    case 'smart_vacuum_cleaner':
      return 'Siurblys';
    case 231:
    case 'car_mat_cleaner':
      return 'Kilimėliai';
    case 241:
    case 'paper_towel_dispenser':
      return 'Šluostės';
    case 251:
    case 'windshield_washer_liquid_dispenser':
      return 'Langų skystis';
    case 261:
    case 'tyre_blackener':
      return 'Juodinimas';
    case 271:
    case 'towel_dispenser':
      return 'Rankšluostis';
    default:
      return '-';
  }
};

export const mapServiceToDeviceType = service => {
  switch (service) {
    case 'self_service_washing':
      return 201;
    case 'automatic_textile_washing':
      return 211;
    case 'automatic_contactless_washing':
      return 212;
    case 'vacuum_cleaner':
      return 221;
    case 'smart_vacuum_cleaner':
      return 222;
    case 'car_mat_cleaner':
      return 231;
    case 'paper_towel_dispenser':
      return 241;
    case 'windshield_washer_liquid_dispenser':
      return 251;
    case 'tyre_blackener':
      return 261;
    case 'towel_dispenser':
      return 271;
    default:
      return 0;
  }
};

export const orderStatuses = [351, 352, 353, 354, 355, 356];

export const mapOrderStatus = type => {
  switch (type) {
    case 351:
      return 'Vykdomas';
    case 352:
      return 'Laukiama mokėjimo';
    case 353:
      return 'Įvykdytas';
    case 354:
      return 'Atmestas';
    case 355:
      return 'Sugedęs';
    case 356:
      return 'Dalinai apmokėtas';
    default:
      return '-';
  }
};

export const membershipOrderStatuses = [551, 552, 553, 554, 555, 556];

export const mapMembershipOrderStatus = status => {
  switch (status) {
    case 551:
      return 'Laukiama';
    case 552:
      return 'Aktyvus';
    case 553:
      return 'Pasibaigęs';
    case 554:
      return 'Deaktyvuotas';
    case 555:
      return 'Neapmokėta';
    case 556:
      return 'Sustabdytas';
    default:
      return '-';
  }
};

export const mapClientPromotions = status => {
  const marketingSettingsCodes = [140, 150, 160];

  if (Array.isArray(status)) {
    const hasAnyEnabledMarketingChannel = status.some(setting =>
      marketingSettingsCodes.includes(Number(setting))
    );

    return hasAnyEnabledMarketingChannel ? 'Sutinka' : 'Nesutinka';
  }

  if (typeof status === 'object' && status !== null) {
    const hasDiscountOfferChannelFields = [
      status.promotions_push,
      status.promotions_sms,
      status.promotions_email,
    ].some(v => v !== undefined && v !== null);

    if (hasDiscountOfferChannelFields) {
      const anyChannelOn =
        Number(status.promotions_push) === 1 ||
        Number(status.promotions_sms) === 1 ||
        Number(status.promotions_email) === 1;

      return anyChannelOn ? 'Sutinka' : 'Nesutinka';
    }

    const communicationSettings = Array.isArray(status.communication_settings)
      ? status.communication_settings
      : [];

    if (communicationSettings.length) {
      const hasAnyEnabledMarketingChannel = communicationSettings.some(
        setting => marketingSettingsCodes.includes(Number(setting))
      );

      return hasAnyEnabledMarketingChannel ? 'Sutinka' : 'Nesutinka';
    }

    if (typeof status.hasConsent === 'boolean') {
      return status.hasConsent ? 'Sutinka' : 'Nesutinka';
    }

    if (status.promotions === 0 || status.promotions === 1) {
      return status.promotions === 1 ? 'Sutinka' : 'Nesutinka';
    }
  }

  switch (status) {
    case 0:
      return 'Nesutinka';
    case 1:
      return 'Sutinka';
    default:
      return '-';
  }
};

export const mapClientCities = id => {
  // TODO: If BE returns city Id then map to values, else delete this
};

export const boxStatuses = [0, 1, 2, 4, 10, 11, 12];

export const mapBoxStatus = status => {
  switch (status) {
    case 0:
      return 'Laisva';
    case 1:
      return 'Užimta';
    case 2:
      return 'Klaida';
    case 4:
      return 'Užbaigta';
    case 5:
      return 'Užimta - kortele';
    case 10:
      return 'Nežinoma';
    case 11:
      return 'Išjungta';
    case 12:
      return 'Nepasiekiama';
    default:
      return '-';
  }
};
export const mapDevicesStatus = status => {
  switch (status) {
    case 0:
      return 'Aktyvi';
    case 1:
      return 'Užimta';
    case 2:
      return 'Klaida';
    case 4:
      return 'Užbaigta';
    case 5:
      return 'Užimta - kortele';
    case 10:
      return 'Nežinoma';
    case 11:
      return 'Išjungta';
    case 12:
      return 'Nepasiekiama';
    default:
      return '-';
  }
};

export const mapServicesStatus = status => {
  switch (status) {
    case 0:
      return 'Išjungta';
    case 1:
      return 'Įjungta';
    default:
      return '-';
  }
};

export const mapDiscountStatusColor = status => {
  switch (status) {
    case 171:
      return 'var(--color__status-orange)';
    case 172:
      return 'var(--color__status-green)';
    case 173:
      return 'var(--color__status-red)';
    case 174:
      return 'var(--color__status-red)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

export const mapMembershipOrderStatusColor = status => {
  switch (status) {
    case 551:
      return 'var(--color__status-orange)';
    case 552:
      return 'var(--color__status-green)';
    case 553:
      return 'var(--color__status-red)';
    case 554:
      return 'var(--color__status-red)';
    case 555:
      return 'var(--color__status-red)';
    case 556:
      return 'var(--color__status-orange)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

export const mapUserStatusColor = status => {
  switch (status) {
    case 1:
      return 'var(--color__status-green)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

export const mapBusinessInvoiceStatusColor = status => {
  switch (status) {
    case 1:
      return 'var(--color__status-dark-grey)';
    default:
      return 'var(--color__status-orange)';
  }
};

export const mapOrderStatusColor = type => {
  switch (type) {
    case 351:
      return 'var(--color__status-blue)';
    case 352:
      return 'var(--color__status-green)';
    case 354:
      return 'var(--color__status-red)';
    case 355:
      return 'var(--color__status-red)';
    case 356:
      return 'var(--color__status-orange)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

export const checkStatusColor = status => {
  switch (status) {
    case 0:
      return 'var(--color__grey)';
    case 1:
      return 'var(--color__success)';
    default:
      return '';
  }
};

export const checkBoxColor = status => {
  switch (status) {
    case 0:
      return 'var(--color__success)';
    case 1:
      return 'var(--color__warning';
    case 2:
    case 4:
    case 10:
    case 11:
    case 12:
      return 'var(--color__grey';
    default:
      return '';
  }
};

export const mapAdyenStatus = status => {
  switch (status) {
    case 450:
      return 'Pradinė rezervacija';
    case 451:
      return 'Ruošiamas';
    case 452:
      return 'Užklausa išsiųsta';
    case 453:
      return 'Rezervuota';
    case 454:
      return 'Nuskaityta';
    case 455:
      return 'Nuskaitymas nepavyko';
    case 456:
      return 'Atšauktas';
    case 457:
      return 'Atšaukimas nepavyko';
    case 458:
      return 'Didina rezervacija';
    case 458:
      return 'Nuskaitymas užklaustas';
    default:
      return '';
  }
};

export const NEUTRAL_DEVICE_STATUS_ICON = Neutral;

export const mapDeviceStatusIcon = status => {
  switch (status) {
    case 0:
      return Active;
    case 1:
      return Active;
    case 4:
      return Active;
    case 5:
      return Active;
    default:
      return InActive;
  }
};

export const mapInvoicePaymentStatus = status => {
  switch (status) {
    case INVOICE_STATUS_NOT_PAID:
      return 'Neapmokėta';
    case INVOICE_STATUS_PAID:
      return 'Apmokėta';
    case INVOICE_STATUS_PARTIALLY_PAID:
      return 'Dalinai apmokėta';
    default:
      return '';
  }
};

export const mapInvoicePaymentStatusColor = status => {
  switch (status) {
    case INVOICE_STATUS_NOT_PAID:
      return 'var(--color__status-orange)';
    case INVOICE_STATUS_PAID:
      return 'var(--color__status-green)';
    case INVOICE_STATUS_PARTIALLY_PAID:
      return 'var(--color__status-yellow)';
    default:
      return '';
  }
};

export const mapBcSyncStatus = status => {
  switch (status) {
    case BC_SYNC_STATUS_SYNCED:
      return 'Sinchronizuota';
    case BC_SYNC_STATUS_FAILED:
      return 'Klaida';
    case BC_SYNC_STATUS_NOT_SENT:
      return 'Neišsiųsta';
    default:
      return '';
  }
};

export const mapBcSyncStatusColor = status => {
  switch (status) {
    case BC_SYNC_STATUS_SYNCED:
      return 'var(--color__status-green)';
    case BC_SYNC_STATUS_FAILED:
      return 'var(--color__status-orange)';
    case BC_SYNC_STATUS_NOT_SENT:
      return 'var(--color__grey)';
    default:
      return '';
  }
};

export const mapAutomaticWashCodeStatuses = status => {
  switch (status) {
    case 1601:
      return 'Apmokėtas';
    case 1602:
      return 'Panaudotas';
    case 1603:
      return 'Galiojiams baigėsi';
    default:
      return '-';
  }
};

export const mapTextileCodeColor = status => {
  switch (status) {
    case 1601:
      return 'var(--color__status-green)';
    default:
      return 'var(--color__status-red)';
  }
};

export const mapCouponType = type => {
  switch (type) {
    case 1501:
      return 'Virtualūs pinigai';
    case 1504:
      return 'Nuolaida vienam užsakymui';
    case 1502:
      return 'Nuolaida laikotarpiui';
    case 1505:
      return 'Nuolaidų planas';
    default:
      return '-';
  }
};

export const mapCouponStatus = status => {
  switch (status) {
    case 1550:
      return 'Reikia aktyvacijos';
    case 1551:
      return 'Galioja';
    case 1552:
      return 'Panaudotas';
    case 1553:
      return 'Pasibaigęs';
    default:
      return '-';
  }
};

export const mapBenefitResetPeriods = type => {
  switch (type) {
    case 51:
      return 'Kasdien';
    case 52:
      return 'Kas savaitę';
    case 53:
      return 'Kas mėnesį';
    default:
      return '';
  }
};

export const mapDiscountPeriods = type => {
  switch (type) {
    case 561:
      return 'Mėnesinė';
    case 562:
      return 'Kasmet';
    default:
      return '';
  }
};

export const mapCampaignStatus = type => {
  switch (type) {
    case CAMPAIGN_STATUS_DRAFT:
      return CAMPAIGN_STATUS_DRAFT_NAME;
    case CAMPAIGN_STATUS_ACTIVE:
      return CAMPAIGN_STATUS_ACTIVE_NAME;
    case CAMPAIGN_STATUS_SENT:
      return CAMPAIGN_STATUS_SENT_NAME;
    case CAMPAIGN_STATUS_ERROR:
      return CAMPAIGN_STATUS_ERROR_NAME;
    default:
      return '';
  }
};

export const mapCampaignStatusColor = status => {
  switch (status) {
    case CAMPAIGN_STATUS_DRAFT:
      return 'var(--color__status-dark-grey)';
    case CAMPAIGN_STATUS_ACTIVE:
      return 'var(--color__status-green)';
    case CAMPAIGN_STATUS_SENT:
      return 'var(--color__status-green)';
    case CAMPAIGN_STATUS_ERROR:
      return 'var(--color__status-red)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

export const mapCampaignType = type => {
  switch (type) {
    case CAMPAIGN_TYPE_SMS:
      return 'SMS';
    case CAMPAIGN_TYPE_PUSH:
      return 'Push';
    case CAMPAIGN_TYPE_SMS_PUSH:
      return 'SMS/Push';
    default:
      return '';
  }
};

export const mapCampaignTypeColor = status => {
  switch (status) {
    case CAMPAIGN_TYPE_SMS:
      return 'var(--color__status-dark-grey)';
    case CAMPAIGN_TYPE_PUSH:
      return 'var(--color__status-dark-grey)';
    case CAMPAIGN_TYPE_SMS_PUSH:
      return 'var(--color__status-dark-grey)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

export const mapLoyaltyProgramStatus = status => {
  switch (status) {
    case LoyaltyProgramStatus.ACTIVE:
      return 'Aktyvus';
    case LoyaltyProgramStatus.INACTIVE:
      return 'Neaktyvus';
    default:
      return '';
  }
};

export const mapLoyaltyProgramStatusColor = status => {
  switch (status) {
    case LoyaltyProgramStatus.ACTIVE:
      return 'var(--color__status-green)';
    case LoyaltyProgramStatus.INACTIVE:
      return 'var(--color__status-red)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

/** Affiliate invite row status (API). */
export const mapAffiliateInviteStatus = status => {
  switch (status) {
    case 1:
      return 'Užsiregistravo';
    case 2:
      return 'Įvykdė';
    case 3:
      return 'Pasibaigė';
    default:
      return '-';
  }
};

export const mapAffiliateInviteStatusColor = status => {
  switch (status) {
    case 1:
      return 'var(--color__status-orange)';
    case 2:
      return 'var(--color__status-green)';
    case 3:
      return 'var(--color__status-dark-grey)';
    default:
      return 'var(--color__status-dark-grey)';
  }
};

export const mapPhysicalCardStatus = status => {
  switch (status) {
    case 0:
      return 'Neaktyvi';
    case 1:
      return 'Aktyvi';
    case 2:
      return 'Pamesta';
    case 3:
      return 'Pasibaigusi';
    default:
      return '-';
  }
};

export const mapPhysicalCardStatusColor = status => {
  switch (status) {
    case 0:
      return 'var(--color__status-orange)';
    case 1:
      return 'var(--color__status-green)';
    case 2:
      return 'var(--color__status-blue)';
    case 3:
      return 'var(--color__status-red)';
    default:
      return '';
  }
};

export const mapPhysicalCardOwnerType = ownerType => {
  switch (ownerType) {
    case 1351:
      return 'Privatus';
    case 1352:
      return 'Verslas';
    default:
      return '-';
  }
};

export const mapPhysicalCardDiscountState = state => {
  switch (state) {
    case 1371:
      return 'Aktyvi';
    case 1372:
      return 'Suplanuota';
    case 1373:
      return 'Pasibaigusi';
    case 1374:
      return 'Nėra';
    default:
      return '-';
  }
};

export const mapPhysicalCardDiscountStateColor = state => {
  switch (state) {
    case 1371:
      return 'var(--color__status-green)';
    case 1372:
      return 'var(--color__status-blue)';
    case 1373:
      return 'var(--color__status-orange)';
    case 1374:
      return 'var(--color__font-dark, #000000)';
    default:
      return '';
  }
};

export const isPhysicalCardBlocked = blocked =>
  blocked === true || blocked === 1 || blocked === 'true';

export const mapPhysicalCardBlocked = blocked =>
  isPhysicalCardBlocked(blocked) ? 'Taip' : 'Ne';

export const mapPhysicalCardBlockedColor = blocked =>
  isPhysicalCardBlocked(blocked)
    ? 'var(--color__status-red)'
    : 'var(--color__font-dark, #000000)';

export const mapPhysicalCardTransactionType = type => {
  switch (type) {
    case 1301:
      return 'Naudojimas';
    case 1302:
      return 'Papildymas';
    case 1303:
      return 'Aktyvavimas';
    case 1304:
      return 'Blokavimas';
    case 1305:
      return 'Atblokavimas';
    default:
      return '-';
  }
};

export const mapPhysicalCardTransactionTypeColor = type => {
  switch (type) {
    case 1301:
      return 'var(--color__status-orange)';
    case 1302:
      return 'var(--color__status-green)';
    case 1303:
      return 'var(--color__status-blue)';
    case 1304:
      return 'var(--color__status-red)';
    case 1305:
      return 'var(--color__status-green)';
    default:
      return '';
  }
};
